import {useDemographicsStyles} from '../admitStyles';
import {useTranslation} from 'react-i18next';
import React from 'react';
import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import Divider from '@mui/material/Divider';
import AdmitHousehold from './admitHousehold';

export default function ChildDetails(props) {
  const classes = useDemographicsStyles();
  const { t } = useTranslation();
  const {
    admit,
    handleChangeInput,
    setAdmit,
    checkDisabled,
    patientIsSelected,
    disabled,
    isAddOnlyPatient,
    mergeToNewCreatedPatient,
  } = props;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            noBorder={false}
            disabled={checkDisabled()}
            variant="outlined"
            label={"School name"}
            className={classes.formControl}
            value={admit.schoolName}
            error={!admit.schoolName}
            name={"schoolName"}
            onChange={handleChangeInput}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <AgyleTextField
            size={"large"}
            fullWidth
            noBorder={false}
            disabled={checkDisabled()}
            variant="outlined"
            label={"School postal code"}
            className={classes.formControl}
            value={admit.schoolPostalCode}
            name={"schoolPostalCode"}
            onChange={handleChangeInput}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            noBorder={false}
            disabled={checkDisabled()}
            variant="outlined"
            label={"School address"}
            className={classes.formControl}
            value={admit.schoolAddress}
            name={"schoolAddress"}
            onChange={handleChangeInput}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <AgyleTextField
            multiline
            noBorder={false}
            disabled={checkDisabled()}
            variant="outlined"
            size="large"
            label={"School contact"}
            className={classes.formControl}
            value={admit.schoolContact}
            fullWidth
            name={"schoolContact"}
            onChange={handleChangeInput}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>

      {!isAddOnlyPatient && patientIsSelected && !mergeToNewCreatedPatient && (
        <>
          <Grid item xs={12} sx={{ my: 2 }}>
            <Divider textAlign="left">Household</Divider>
          </Grid>

          <AdmitHousehold
            admit={admit}
            setAdmit={setAdmit}
            checkDisabled={checkDisabled}
            disabled={disabled}
          />
        </>
      )}
    </>
  );
}
